import { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { TooltipHoverPresentationProps } from "@waytek/MobiusOverrides/Tooltip/TooltipHover";
import { colorPalette } from "@waytek/Utilities/variables";
import { css } from "styled-components";

export const tooltip: { defaultProps?: TooltipPresentationProps } = {
    defaultProps: {
        cssOverrides: {
            tooltipContainer: css`
                margin-bottom: 5px;

                &::after {
                    border-color: ${colorPalette.common.global.white} transparent transparent transparent;
                    margin-top: -1px;
                }

                &::before {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    margin-left: -7px;
                    border-width: 7px;
                    border-style: solid;
                    border-color: ${colorPalette.common.global.lightGray} transparent transparent transparent;
                    margin-top: -1px;
                }
            `,

            tooltipBody: css`
                background: ${colorPalette.common.global.white};
                border: solid 1px ${colorPalette.common.global.lightGray};
                padding: 7px 10px;
                border-radius: 0;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
                min-width: auto;

                ${TypographyStyle} {
                    font-size: 12px;
                    color: ${colorPalette.common.global.secondaryGray};
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                }
            `,
        },
    },
};

export const tooltipHover: { defaultProps?: TooltipHoverPresentationProps } = {
    defaultProps: {
        cssOverrides: {
            tooltipContainer: css`
                margin-bottom: 5px;
            `,

            tooltipBody: css`
                background: ${colorPalette.common.global.white};
                border: solid 1px ${colorPalette.common.global.lightGray};
                padding: 7px 10px;
                border-radius: 0;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
                min-width: auto;

                ${TypographyStyle} {
                    font-size: 12px;
                    color: ${colorPalette.common.global.secondaryGray};
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                }
            `,
        },
    },
};
